var primitiveButton = 'fx_b6b0f3e6_163p7g20';
var primitiveButtonClickableVariants = {weak:'fx_b6b0f3e6_163p7g21','default':'fx_b6b0f3e6_163p7g22',strong:'fx_b6b0f3e6_163p7g23',none:'fx_b6b0f3e6_163p7g24'};

export { primitiveButton, primitiveButtonClickableVariants };
//# sourceMappingURL=primitiveButton.vanilla.mjs.map
